import { useEffect, useRef } from 'react'

import { isEqual } from 'lodash'

export const useWatcher = <V extends any[]>(
  callback: (...args: V) => void,
  deps: V
): void => {
  const previous = useRef<V>(deps)

  useEffect(() => {
    if (!isEqual(previous.current, deps)) {
      previous.current = deps

      callback(...deps)
    }
  }, deps)
}
